<template>
  <div>
        <div v-if="!read_only" style="width: 100%; text-align: right; margin-bottom: 10px;">
            <el-button 
                @click="processQC('reject')"
                v-if="getQCChart.filter(t => t.status === 2).length>0"
                size="small"
                :type="'danger'"
                :disabled="getQCChart.filter(t => t.status === 0).length > 0">
                Reject
            </el-button>
            <el-button 
                @click="processQC('accept')"
                v-else
                size="small"
                :type="'success'"
                :disabled="getQCChart.filter(t => t.status === 0).length > 0">
                Accept
            </el-button>
        </div>

        <el-table
         v-if="getQCChart !== null"
         :data="getQCChart"
         style="width: 100%">
            <el-table-column 
                prop="quality_point"
                label="Check-Point">
                <template slot-scope="scope">
                    {{scope.row.quality_point}}
                </template>
            </el-table-column>
            <el-table-column 
                prop="status"
                label="">
                <template slot-scope="scope">
                    <el-radio :disabled="read_only" :label="1" v-model="scope.row.status">
                        Ok
                    </el-radio>
                    <el-radio :disabled="read_only" :label="2" v-model="scope.row.status">
                        Reject
                    </el-radio>
                </template>
            </el-table-column>
            <el-table-column 
                prop="comment"
                label="Comment">
                <template slot-scope="scope">
                    <el-input 
                    :disabled="read_only" 
                    @focus="$event.target.select()"
                    size="small"
                    v-model.trim="scope.row.comment"
                    style="width: 100%;">
                </el-input>
                </template>
            </el-table-column>
            
        </el-table>
        <div v-if="!read_only" style="width: 100%; text-align: right; margin-top: 20px;">
            <el-button 
                @click="processQC('reject')"
                v-if="getQCChart.filter(t => t.status === 2).length>0"
                size="small"
                :type="'danger'"
                :disabled="getQCChart.filter(t => t.status === 0).length > 0">
                Reject
            </el-button>
            <el-button 
                @click="processQC('accept')"
                v-else
                size="small"
                :type="'success'"
                :disabled="getQCChart.filter(t => t.status === 0).length > 0">
                Accept
            </el-button>
        </div>
  </div>
</template>

<script>
export default {
    props: ['row_data', 'read_only'],
    computed: {
        getQCChart() {
            return this.row_data.qc_chart
        },
        getRowData() {
            return this.row_data
        }
    },
    methods: {
        processQC(action_type) {
            this.$confirm('Are you sure to submit?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.submitQC(action_type)
            }).catch(() => {
                    
            });
            
        },
       async submitQC(action_type) {

            let itemPlacementRackNumber = "";
            if(this.$store.getters.getPreferenceProps.production_assign_work_order_rack_number) {
                    this.$prompt('Mention Item Placement Rack No.', 'Request', {
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                    }).then(({ value }) => {
                        if(value.length === 0) {
                            this.$alert('Rack no. is required, please try again!!!', 'Error');
                            return    
                        }
                        itemPlacementRackNumber = value;
                        this.$store.dispatch('updateWorkOrderAssignment', {
                            action_type: action_type, 
                            production_id: this.getRowData.id,
                            work_log_id: this.getRowData.production_work_log_id, 
                            worker_id: this.getRowData.worker_id,
                            work_order_process_id: this.getRowData.work_order_process_id,
                            process_id: this.getRowData.process_id,
                            sub_tailoring_item_id: this.getRowData.sub_tailoring_item_id,
                            tailoring_item_id: this.getRowData.tailoring_item_id,
                            remarks: this.getRowData.remarks,
                            qc_chart: this.getQCChart,
                            item_placement_rack_number: itemPlacementRackNumber,
                            update_finished_item: false,
                            trial: this.getRowData.appointment_type === 1
                        })
                    }).catch(() => {
                        this.$alert('Rack no. is required, please try again!!!', 'Error');
                        return
                    });
            } else {
                await this.$store.dispatch('updateWorkOrderAssignment', {
                    action_type: action_type, 
                    production_id: this.getRowData.id,
                    work_log_id: this.getRowData.production_work_log_id, 
                    worker_id: this.getRowData.worker_id,
                    work_order_process_id: this.getRowData.work_order_process_id,
                    process_id: this.getRowData.process_id,
                    sub_tailoring_item_id: this.getRowData.sub_tailoring_item_id,
                    tailoring_item_id: this.getRowData.tailoring_item_id,
                    remarks: this.getRowData.remarks,
                    qc_chart: this.getQCChart,
                    item_placement_rack_number: itemPlacementRackNumber,
                    update_finished_item: false,
                    trial: this.getRowData.appointment_type === 1
                })
            }
            

            setTimeout(() => {
                this.$emit('closed')
            }, 1000);
        }
    },
    mounted() {
        setTimeout(() => {
            if(this.getQCChart === null) {
                this.row_data.qc_chart = []
            }
            if(this.getQCChart.length === 0) {
                let list = []
                let key = 0
                this.$store.getters.getItemCategoryDataProps.quality_point_list.forEach(element => {
                    list.push({
                        key: key,
                        quality_point: element.quality_point,
                        status: 0, //1=ok, 2=reject
                        comment: ''
                    })
                    key ++
                })
                this.$store.getters.getProductionStageDataProps.quality_point_list.forEach(element => {
                    list.push({
                        key: key,
                        quality_point: element.quality_point,
                        status: 0, //1=ok, 2=reject
                        comment: ''
                    })
                    key ++
                })

                if(list.length === 0) {
                    list.push({
                        key: 0,
                        quality_point: 'Everything OK?',
                        status: 0,
                        comment: ''
                    })
                }
                this.row_data.qc_chart = list
            }
        }, 1000);
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Production/QCWindow.vue